export class PdfChart {
  pdf = false;
  className = {};
  constructor() {}
  setPdf = pdf => {
    pdf === undefined ? (this.pdf = false) : (this.pdf = pdf);
    this.className = { chart: true, pdf: this.pdf };
  };
}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/shared/pdfChart.ts